import {FC} from 'react';

import {Skeleton, Stack, Typography, useMediaQuery} from '@mui/material';
import i18n, {t} from 'i18next';

import LargeChevronRight from 'assets/icons/largeChevronRight';
import theme from 'config/theme';
import {useAppSelector} from 'hooks';
import ReactNative from 'services/react-native';
import {ShippingAddressType} from 'types';
import {getStringFormOfAddress} from 'utils/address';

import {
  ShipToLabelWrapper,
  ShippingAddressWrapper,
  CompleteMyAddressWrapper,
  StyledChevronRight,
  StyledPinDrop
} from './styles';

export const ShippingAddress: FC<ShippingAddressType> = ({
  address,
  isLoading: isLoadingAddress,
  onClick: clickCallback
}) => {
  const {idToken} = useAppSelector((state) => state?.auth) || {};
  const {currentStore} = useAppSelector((state) => state?.app);
  const isMobileView = useMediaQuery(theme.breakpoints.only('mobile'));
  const zipCode = currentStore?.zipcode || '';
  const isThai = i18n.language === 'th';
  const isReactNativeView = ReactNative.isReactNativeWebView();
  const isMobileScreen = isReactNativeView || isMobileView;

  const addressLine = () => {
    if (address === undefined) {
      return (
        <>
          {zipCode}
          <CompleteMyAddressWrapper> ({t('label.completeMyAddress')})</CompleteMyAddressWrapper>
        </>
      );
    }

    if (!address.address1) {
      return (
        <>
          {address.zip}
          <CompleteMyAddressWrapper> ({t('label.completeMyAddress')})</CompleteMyAddressWrapper>
        </>
      );
    }

    return getStringFormOfAddress(address, isThai, false);
  };

  const ShippingAddressSkeleton = () => (
    <Stack spacing={1}>
      <Skeleton variant="rectangular" height={30} sx={{borderRadius: 2}} />
    </Stack>
  );

  const onShippingAddressClick = () => {
    if (!idToken) {
      // router.replace(getAuthRedirectURI(i18n.language, 'auth/login'));
    } else {
      clickCallback && clickCallback();
    }
  };

  if (!idToken) {
    return null;
  }

  return (
    <div
      style={{
        backgroundColor: isMobileScreen ? '#F4F4F4' : 'white',
        boxShadow: isMobileScreen ? '0px 4px 12px 0px rgba(0, 0, 0, 0.08)' : 'none',
        zIndex: isMobileScreen ? '1000' : 'none'
      }}
      data-test-id={'basket_shipping_address'}
    >
      {isLoadingAddress ? (
        <ShippingAddressSkeleton />
      ) : (
        <ShippingAddressWrapper
          onClick={() => {
            onShippingAddressClick();
          }}
          isReactNativeView={isMobileScreen}
        >
          <StyledPinDrop sx={{fontSize: 18}} color="primary" />
          <ShipToLabelWrapper>
            <Typography>
              <b>{t('label.shipTo')}</b>
            </Typography>
          </ShipToLabelWrapper>
          <Typography overflow={'hidden'} flexGrow={1} textOverflow={'ellipsis'} whiteSpace={'nowrap'}>
            {addressLine()}
          </Typography>
          {isMobileScreen ? <LargeChevronRight width={35} /> : <StyledChevronRight />}
        </ShippingAddressWrapper>
      )}
    </div>
  );
};

ShippingAddress.displayName = 'ShippingAddess';

export default ShippingAddress;
